import dayjs from 'dayjs';
import { TNote } from '@/components/tour/notes/types';

export function getUnoccupiedTimeslots(
  date: Date,
  { notes, assigneeId, timeSlots }: { notes: TNote[]; assigneeId: string; timeSlots: number[] },
) {
  const currentDay = dayjs(date).startOf('day');
  const selectedDayNotes = notes
    .filter((note) => note.assignee === assigneeId && !note.backlogEnabled)
    .filter((note) => dayjs(note.dueDate).isSame(currentDay, 'day'));

  // Get all occupied time ranges (2 hours before and after each note's due date)
  const occupiedRanges = selectedDayNotes.map((note) => {
    const noteDueDate = dayjs(note.dueDate);
    const noteMinutes = noteDueDate.hour() * 60 + noteDueDate.minute();
    return {
      start: noteMinutes - 119, // 2 hours before
      end: noteMinutes + 119, // 2 hours after
    };
  });

  return timeSlots.filter((minutes) => {
    return !occupiedRanges.some((range) => minutes >= range.start && minutes <= range.end);
  });
}

export function getFirstAvailableTimeSlot(
  startDate: Date,
  {
    notes,
    assigneeId,
    timeSlots,
    maxIterateDays,
  }: { notes: TNote[]; assigneeId: string; timeSlots: number[]; maxIterateDays: number },
) {
  let currentDate = dayjs(startDate);

  for (let i = 0; i < maxIterateDays; i += 1) {
    const availableTimeSlots = getUnoccupiedTimeslots(currentDate.toDate(), {
      notes,
      assigneeId,
      timeSlots,
    }).filter((minutes) => {
      // On the first day, filter out time slots that are before the start time
      if (i === 0) {
        const start = dayjs(startDate);
        const totalMinutes = start.hour() * 60 + start.minute();
        return minutes >= totalMinutes;
      }

      return true;
    });

    if (availableTimeSlots.length > 0) {
      // Return the first available time slot for this day
      const firstTimeSlot = availableTimeSlots[0];
      return currentDate
        .hour(Math.floor(firstTimeSlot / 60))
        .minute(firstTimeSlot % 60)
        .second(0)
        .millisecond(0)
        .toDate();
    }

    currentDate = currentDate.add(1, 'day');
  }

  return null;
}
